import { postMessage } from './frameEvents.js';

const omsTargetOrigins = [
	// Non-prod
	'https://order-local.partners.avast.com',
	'https://order-test.partners.avast.com',
	'https://order-stage.partners.avast.com',
	// Prod
	'https://order.partners.avast.com'
];

/**
 * @typedef {object} OmsPurchaseFrameEventPayload
 * @property {string} commerceOrderId Order ID from the commerce platform (eg. eStore orderNumber)
 */

/**
 * Send purchase event to the OMS frame
 * @param {OmsPurchaseFrameEventPayload} options
 */
export const purchase = ({ commerceOrderId }) => {
	postMessage({
		type: 'purchase',
		commerceOrderId
	}, omsTargetOrigins);
};
